/**
 * Optional archive note on list rows (document requests, VQQ/RFI lists, assessments).
 * Tries several API property names so grids stay compatible as backends evolve.
 */
export function getGridArchiveCommentDisplay(item) {
  const v =
    item?.archive_comment ??
    item?.ArchiveComment ??
    item?.archiveComment ??
    item?.request_archive_comment ??
    item?.vqa_archive_comment ??
    item?.admin_archive_comment ??
    "";
  if (v == null || v === "") return "";
  return String(v).trim();
}
